import {
  addCivilDays,
  addCivilMonths,
  endOfCivilMonth,
  startOfCivilMonth,
  type CivilDate,
} from "./civil-date";

/**
 * Focus movement inside a calendar grid.
 *
 * One tab stop for the whole grid, with the keyboard moving **inside** it: as a list of buttons,
 * a month would be thirty-one tab stops between the heading and the next field. Pure and apart
 * from the component because the part that gets it wrong is the arithmetic.
 */

export const CALENDAR_KEYS = [
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
  "PageUp",
  "PageDown",
] as const;

export type CalendarKey = (typeof CALENDAR_KEYS)[number];

export function isCalendarKey(key: string): key is CalendarKey {
  return (CALENDAR_KEYS as readonly string[]).includes(key);
}

/** A week apart is what separates two rows of the grid. */
const DAYS_IN_WEEK = 7;

export function moveCalendarFocus(from: CivilDate, key: CalendarKey): CivilDate {
  switch (key) {
    case "ArrowLeft":
      return addCivilDays(from, -1);
    case "ArrowRight":
      return addCivilDays(from, 1);
    case "ArrowUp":
      return addCivilDays(from, -DAYS_IN_WEEK);
    case "ArrowDown":
      return addCivilDays(from, DAYS_IN_WEEK);
    case "Home":
      return startOfCivilMonth(from);
    case "End":
      return endOfCivilMonth(from);
    case "PageUp":
      return addCivilMonths(from, -1);
    case "PageDown":
      return addCivilMonths(from, 1);
  }
}
